import { render, staticRenderFns } from "./RichTextSubscript.vue?vue&type=template&id=7ceff967&scoped=true&"
import script from "./RichTextSubscript.vue?vue&type=script&lang=js&"
export * from "./RichTextSubscript.vue?vue&type=script&lang=js&"
import style0 from "./RichTextSubscript.vue?vue&type=style&index=0&id=7ceff967&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ceff967",
  null
  
)

export default component.exports